import crypto from "crypto-random-string";

export const validateCPF = (strCPF = '') => {
    let soma;
    let resto;
    soma = 0;

    strCPF = strCPF.replace(/[\\.|\\-]/g, '')

    if (strCPF === "00000000000") return false;
    if (strCPF.length < 11) return false;

    for (let i = 1; i <= 9; i++) soma = soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
    resto = (soma * 10) % 11;

    if ((resto === 10) || (resto === 11)) resto = 0;
    if (resto !== parseInt(strCPF.substring(9, 10))) return false;

    soma = 0;
    for (let i = 1; i <= 10; i++) soma = soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
    resto = (soma * 10) % 11;

    if ((resto === 10) || (resto === 11)) resto = 0;
    if (resto !== parseInt(strCPF.substring(10, 11))) return false;
    return true;
};

export const validateEmail = (mail) => {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
        return true
    }

    return false;
};

export const generatePassword = () => {
    return crypto({length: 10})
};